import {
	CREATE_PARTS_QUANTITIES,
	CREATE_PARTS_QUANTITIES_FAIL,
	CREATE_PARTS_QUANTITIES_SUCCESS,
	DELETE_BINDING_NOTES,
	DELETE_BINDING_NOTES_FAIL,
	DELETE_BINDING_NOTES_SUCCESS,
	GET_OFFER_FILTERED_PARTS,
	GET_OFFER_FILTERED_PARTS_FAIL,
	GET_OFFER_FILTERED_PARTS_SUCCESS,
	GET_ORDER_FILTERED_PARTS,
	GET_ORDER_FILTERED_PARTS_FAIL,
	GET_ORDER_FILTERED_PARTS_SUCCESS,
	GET_PART_CONFIG_OPTIONS,
	GET_PART_CONFIG_OPTIONS_FAIL,
	GET_PART_CONFIG_OPTIONS_SUCCESS,
	GET_PARTS_PREDICTS_AND_REAL,
	GET_PARTS_PREDICTS_AND_REAL_FAIL,
	GET_PARTS_PREDICTS_AND_REAL_SUCCESS,
	GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS,
	GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS_FAIL,
	GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS_SUCCESS,
	CREATE_PART_STEP_ANALYSIS,
	CREATE_PART_STEP_ANALYSIS_FAIL,
	CREATE_PART_STEP_ANALYSIS_SUCCESS,
	GET_SIMILAR_PARTS_DETAIL,
	GET_SIMILAR_PARTS_DETAIL_FAIL,
	GET_SIMILAR_PARTS_DETAIL_SUCCESS,
	GET_TECHNOLOGIES_DASHBOARD,
	GET_TECHNOLOGIES_DASHBOARD_FAIL,
	GET_TECHNOLOGIES_DASHBOARD_SUCCESS,
	UPDATE_BINDING_NOTES,
	UPDATE_BINDING_NOTES_FAIL,
	UPDATE_BINDING_NOTES_SUCCESS,
	UPDATE_PARTS,
	UPDATE_PARTS_FAIL,
	UPDATE_PARTS_STATUS,
	UPDATE_PARTS_STATUS_FAIL,
	UPDATE_PARTS_STATUS_SUCCESS,
	UPDATE_PARTS_SUCCESS,
	ANALYZE_STEP_ONSHAPE_FAIL,
	ANALYZE_STEP_ONSHAPE_SUCCESS,
	ANALYZE_STEP_ONSHAPE,
	ANALYZE_STEP_OPENCASCADE_FAIL,
	ANALYZE_STEP_OPENCASCADE_SUCCESS,
	ANALYZE_STEP_OPENCASCADE,
	DELETE_PART_STEP_ANALYSIS_FAIL,
	DELETE_PART_STEP_ANALYSIS_SUCCESS,
	DELETE_PART_STEP_ANALYSIS,
	UPLOAD_AND_CONVERT_TO_STEP_FAIL,
	UPLOAD_AND_CONVERT_TO_STEP_SUCCESS,
	UPLOAD_AND_CONVERT_TO_STEP,
} from './actionTypes'

export const getPartsPredictsAndReal = () => ({
	type: GET_PARTS_PREDICTS_AND_REAL,
})

export const getPartsPredictsAndRealSuccess = (response) => ({
	type: GET_PARTS_PREDICTS_AND_REAL_SUCCESS,
	payload: response,
})

export const getPartsPredictsAndRealFail = (error) => ({
	type: GET_PARTS_PREDICTS_AND_REAL_FAIL,
	payload: error,
})

export const updatePartsStatus = (partIds, statusId, suppliers, editingWithinBindingNoteModal, newPartsStatus) => ({
	type: UPDATE_PARTS_STATUS,
	payload: { partIds, statusId, suppliers, editingWithinBindingNoteModal, newPartsStatus },
})
export const updatePartsStatusSuccess = (response, editingWithinBindingNoteModal) => ({
	type: UPDATE_PARTS_STATUS_SUCCESS,
	payload: { response, editingWithinBindingNoteModal },
})
export const updatePartsStatusFail = (error, editingWithinBindingNoteModal) => ({
	type: UPDATE_PARTS_STATUS_FAIL,
	payload: { error, editingWithinBindingNoteModal },
})

export const createPartsQuantities = ({ partIds, quantities }) => ({
	type: CREATE_PARTS_QUANTITIES,
	payload: { partIds, quantities },
})
export const createPartsQuantitiesSuccess = (response) => ({
	type: CREATE_PARTS_QUANTITIES_SUCCESS,
	payload: { response },
})
export const createPartsQuantitiesFail = (error) => ({
	type: CREATE_PARTS_QUANTITIES_FAIL,
	payload: { error },
})

export const getPartConfigOptions = payload => ({
	type: GET_PART_CONFIG_OPTIONS,
	payload: payload,
})
export const getPartConfigOptionsSuccess = payload => ({
	type: GET_PART_CONFIG_OPTIONS_SUCCESS,
	payload: payload,
})
export const getPartConfigOptionsFail = payload => ({
	type: GET_PART_CONFIG_OPTIONS_FAIL,
	payload: payload,
})

export const updateParts = (payload, context) => ({
	type: UPDATE_PARTS,
	payload: payload,
	context: context,
})
export const updatePartsSuccess = (payload, context) => ({
	type: UPDATE_PARTS_SUCCESS,
	payload: payload,
	context: context,
})
export const updatePartsFail = (payload, context) => ({
	type: UPDATE_PARTS_FAIL,
	payload: payload,
	context: context,
})

export const getOfferFiltredParts = (input, signal) => ({
	type: GET_OFFER_FILTERED_PARTS,
	payload: { input, signal },
})
export const getOfferFiltredPartsSuccess = (response) => ({
	type: GET_OFFER_FILTERED_PARTS_SUCCESS,
	payload: response,
})
export const getOfferFiltredPartsFail = (error) => ({
	type: GET_OFFER_FILTERED_PARTS_FAIL,
	payload: { error },
})

export const getOrderFiltredParts = (input, signal) => ({
	type: GET_ORDER_FILTERED_PARTS,
	payload: { input, signal },
})
export const getOrderFiltredPartsSuccess = (response) => ({
	type: GET_ORDER_FILTERED_PARTS_SUCCESS,
	payload: response,
})
export const getOrderFiltredPartsFail = (error) => ({
	type: GET_ORDER_FILTERED_PARTS_FAIL,
	payload: { error },
})

export const getPartsStepAnalysisByPartsIds = (partId) => ({
	type: GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS,
	payload: { partId },
})
export const getPartsStepAnalysisByPartsIdsSuccess = (response, metadata) => ({
	type: GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS_SUCCESS,
	payload: { response, metadata },
})
export const getPartsStepAnalysisByPartsIdsFail = (error, metadata) => ({
	type: GET_PARTS_STEP_ANALYSIS_BY_PARTS_IDS_FAIL,
	payload: { error, metadata },
})

export const createPartStepAnalysis = (partId, stepAnalysisBase64) => ({
	type: CREATE_PART_STEP_ANALYSIS,
	payload: { partId, stepAnalysisBase64 },
})
export const createPartStepAnalysisSuccess = (response, metadata) => ({
	type: CREATE_PART_STEP_ANALYSIS_SUCCESS,
	payload: { response, metadata },
})
export const createPartStepAnalysisFail = (error, metadata) => ({
	type: CREATE_PART_STEP_ANALYSIS_FAIL,
	payload: { error, metadata },
})

export const getSimilarPartsDetail = (partIds) => ({
	type: GET_SIMILAR_PARTS_DETAIL,
	payload: { partIds },
})
export const getSimilarPartsDetailSuccess = (response) => ({
	type: GET_SIMILAR_PARTS_DETAIL_SUCCESS,
	payload: response,
})
export const getSimilarPartsDetailFail = (error) => ({
	type: GET_SIMILAR_PARTS_DETAIL_FAIL,
	payload: { error },
})

export const updateBindingNotes = ({ partIds, bindingNoteTypesIds, comment }) => ({
	type: UPDATE_BINDING_NOTES,
	payload: { partIds, bindingNoteTypesIds, comment },
})
export const updateBindingNotesSuccess = (response) => ({
	type: UPDATE_BINDING_NOTES_SUCCESS,
	payload: { response },
})
export const updateBindingNotesFail = (error) => ({
	type: UPDATE_BINDING_NOTES_FAIL,
	payload: error,
})

export const deleteBindingNotes = ({ partIds }) => ({
	type: DELETE_BINDING_NOTES,
	payload: { partIds },
})
export const deleteBindingNotesSuccess = (response) => ({
	type: DELETE_BINDING_NOTES_SUCCESS,
	payload: { response },
})
export const deleteBindingNotesFail = (error) => ({
	type: DELETE_BINDING_NOTES_FAIL,
	payload: error,
})

export const getTechnologiesDashboard = (data) => ({
	type: GET_TECHNOLOGIES_DASHBOARD,
	payload: { data },
})

export const getTechnologiesDashboardSuccess = (response) => ({
	type: GET_TECHNOLOGIES_DASHBOARD_SUCCESS,
	payload: response,
})

export const getTechnologiesDashboardFail = (error) => ({
	type: GET_TECHNOLOGIES_DASHBOARD_FAIL,
	payload: error,
})

export const deletePartStepAnalysis = (partId) => ({
	type: DELETE_PART_STEP_ANALYSIS,
	payload: { partId },
})
export const deletePartStepAnalysisSuccess = (response, metadata) => ({
	type: DELETE_PART_STEP_ANALYSIS_SUCCESS,
	payload: { response, metadata },
})
export const deletePartStepAnalysisFail = (error, metadata) => ({
	type: DELETE_PART_STEP_ANALYSIS_FAIL,
	payload: { error, metadata },
})

// NOTE: Setting OnShape IDs on a part reuses the existing updateParts action — no new action needed.
// Dispatch: updateParts({ parts: [{ id: partId, did, wid, tid, eid }] }, { id: partId })

/**
 * @param {{ partId: number, otherFile: File }} payload
 * @param {{ id: number }} metadata
 */
export const uploadAndConvertToStep = (payload, metadata) => ({
	type: UPLOAD_AND_CONVERT_TO_STEP,
	payload,
	metadata,
})
/**
 * Note: response contains a File object (stepFile, non-serializable).
 * Add UPLOAD_AND_CONVERT_TO_STEP_SUCCESS to serializableCheck.ignoredActions if needed.
 * @param {{ stepFile: File, onShapeIds: { did: string, wid: string, tid: string, eid: string } }} payload
 * @param {{ id: number }} metadata
 */
export const uploadAndConvertToStepSuccess = (payload, metadata) => ({
	type: UPLOAD_AND_CONVERT_TO_STEP_SUCCESS,
	payload,
	metadata,
})
/**
 * @param {any} payload
 * @param {{ id: number }} metadata
 */
export const uploadAndConvertToStepFail = (payload, metadata) => ({
	type: UPLOAD_AND_CONVERT_TO_STEP_FAIL,
	payload,
	metadata,
})

/**
 * Note: payload contains a File object (non-serializable).
 * Add ANALYZE_STEP_OPENCASCADE to serializableCheck.ignoredActions if needed.
/**
 * @param {{ partId: number, stepFile: File }} payload
 * @param {{ id: number }} metadata
 */
export const analyzeStepOpenCascade = (payload, metadata) => ({
	type: ANALYZE_STEP_OPENCASCADE,
	payload,
	metadata,
})
/**
 * @param {{ stepAnalysis: any, stepAnalysisBase64: any, stlFile: File }} payload
 * @param {{ id: number }} metadata
 */
export const analyzeStepOpenCascadeSuccess = (payload, metadata) => ({
	type: ANALYZE_STEP_OPENCASCADE_SUCCESS,
	payload,
	metadata,
})
/**
 * @param {any} payload
 * @param {{ id: number }} metadata
 */
export const analyzeStepOpenCascadeFail = (payload, metadata) => ({
	type: ANALYZE_STEP_OPENCASCADE_FAIL,
	payload,
	metadata,
})

/**
 * @param {{ onShapeIds: { did: string, wid: string, tid: string, eid: string }, partId: number, filename: string }} payload
 * @param {{ id: number }} metadata
 */
export const analyzeStepOnShape = (payload, metadata) => ({
	type: ANALYZE_STEP_ONSHAPE,
	payload,
	metadata,
})
/**
 * Note: response contains a File object (stlFile, non-serializable).
 * Add ANALYZE_STEP_ONSHAPE_SUCCESS to serializableCheck.ignoredActions if needed.
 * @param {{ cadData: object, stlFile: File }} payload
 * @param {{ id: number }} metadata
 */
export const analyzeStepOnShapeSuccess = (payload, metadata) => ({
	type: ANALYZE_STEP_ONSHAPE_SUCCESS,
	payload,
	metadata,
})
/**
 * @param {any} payload
 * @param {{ id: number }} metadata
 */
export const analyzeStepOnShapeFail = (payload, metadata) => ({
	type: ANALYZE_STEP_ONSHAPE_FAIL,
	payload,
	metadata,
})

